@if (file) {
  <mat-card
    class="file-card"
    appearance="outlined"
    [ngStyle]="{ 'background-color': fileColorMap[file.extension ?? 'txt'] }"
  >
    <div class="file-card-content">
      <!-- FILE ICON -->
      <div class="file-icon-wrapper">
        <img class="file-icon-img" [src]="getLogoFile(file)" alt="file-icon" />
      </div>

      <!-- FILE MENU -->
      <div class="file-menu">
        <app-menu-folder
          [isFile]="true"
          [fileSelezionato]="file"
          [isModulo]="isModulo"
        ></app-menu-folder>
      </div>
    </div>

    <mat-card-footer class="file-footer">
      <div [matTooltip]="file.name" class="file-name">{{ file.name }}</div>
    </mat-card-footer>
  </mat-card>
}
